import useApiQuery from '@hooks/useApiQuery';
import QueryKeys from '@src/constants/queryKeys';
import { Device } from '@src/types/Device';

export interface UseGetDevicesFilteredBody {
  filter: {
    type?: {
      $in: string[];
    };
    parentSourceDeviceId?: string;
    engineeringId?: string;
    parentControllerId?: string;
  };
}
export interface UseGetDevicesProps {
  body: UseGetDevicesFilteredBody;
  options?: {
    enabled?: boolean;
    queryKeys?: string[];
    select?: (data: unknown) => unknown;
  };
}

export default ({
  body,
  options,
}: UseGetDevicesProps): ReturnType<typeof useApiQuery<Device[]>> =>
  useApiQuery<Device[]>({
    queryKey: [QueryKeys.devices, ...(options?.queryKeys || [])],
    apiPath: '/devices/search',
    method: 'POST',
    useV2API: true,
    body,
    enabled: typeof options?.enabled === 'boolean' ? options.enabled : true,
    select: options?.select,
  });
